import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

// Estado de carga / sin datos de un gráfico: siempre centrado y contenido
// dentro de la tarjeta, sin posicionamiento absoluto
const ChartPlaceholder = ({ darkMode, loading, image, message }) => (
  <Grid
    sx={{
      flex: 1,
      width: "100%",
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "10px",
      overflow: "hidden",
    }}
  >
    {loading ? (
      <CircularProgress
        sx={{ color: "#4E5589" }}
        size={50}
        variant="indeterminate"
      />
    ) : (
      <>
        <Box
          component="img"
          src={image}
          alt=""
          sx={{
            flex: "1 1 auto",
            minHeight: 0,
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            objectFit: "contain",
          }}
        />
        <Typography
          sx={{
            fontSize: "14px !important",
            textAlign: "center",
            color: darkMode ? "white" : "#00000080",
          }}
        >
          {message}
        </Typography>
      </>
    )}
  </Grid>
);

ChartPlaceholder.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  image: PropTypes.string.isRequired,
  message: PropTypes.string,
};

ChartPlaceholder.defaultProps = {
  loading: false,
  message: "El gráfico aún no se encuentra disponible",
};

export default ChartPlaceholder;
